<template>
  <div class="address">
    <Spin v-if="isLoading" size="large" fix></Spin>
    <section :class="['business-type', { 'business-type-block': type === '2' }]">
      <!-- 请选择您的就餐类型 -->
      <h3>{{ $t('tip.input.business')}}</h3>
      <RadioGroup v-model="type">
        <!-- 外送 -->
        <Radio class="business-type-radio" label="1">{{ $t('text.address.business[0]') }}</Radio>
        <!-- 外带 -->
        <Radio class="business-type-radio" label="2">{{ $t('text.address.business[1]') }}</Radio>
      </RadioGroup>
    </section>
    <section v-show="type === '1'" class="address-list">
      <!-- 您还可以在送餐库中选择 -->
      <h3>{{ $t('text.address.alsoSelect') }}</h3>
      <div class="address-list-item">
        <ul v-for="address in addressList" :key="address.aid" @click.stop="toUserAddress(address, 'no')">
          <!-- 姓名 -->
          <li>
            {{ $t('user.name') }}
            &nbsp;&nbsp;:&nbsp;&nbsp;{{ address.receiverName }}
          </li>
          <!-- 电话 -->
          <li>
            {{ $t('user.phone.mobile') }}
            &nbsp;&nbsp;:&nbsp;&nbsp;{{ address.receiverPhone }}
          </li>
          <!-- 地址 -->
          <li>
            {{ $t('user.addr') }}
            &nbsp;&nbsp;:&nbsp;&nbsp;
            {{ address.receiverAddress + (address.appendReceiverAddress || '')}}
          </li>
        </ul>
      </div>
    </section>
    <section class="address-select">
      <!-- 请输入您的地址 -->
      <h3>{{ $t('tip.input.address2') }}</h3>
      <div class="content-address" v-show="type === '1'">
        <v-city-select ref="city" class="global-select content-address-select" :city="cityData" @select="handleSelectCity">
          <span slot="tip" class="global-city-select-tips">
            {{ selectCity.city ? selectCity.city.cityName : $t('text.select[0]') }}
            <v-icon type="md-arrow-dropdown" />
          </span>
          <div slot="title" class="global-city-select-title">
            <!-- 请选择你所在的省份 -->
            <span>{{ $t('center.addrmanage.select.province[0]') }}</span>
            <!-- 重新选择省份 -->
            <span class="back" @click="selectCity.province = null" v-if="selectCity.province !== null">
              &nbsp;
              {{ $t('center.addrmanage.select.province[1]') }}
            </span>
          </div>
        </v-city-select>
        <i>
          <span></span>
        </i>
        <Select
          class="iview-input iview-input-no-borderLs view-select-none-border"
          v-model="address"
          filterable
          remote
          label-in-value
          :remote-method="autoComplete"
          :loading="isShowSearchResult"
          @on-change="checkItem"
          :label="address || null"
        >
          <Option
            v-for="(addr, index) in searchAddressList"
            :value="addr.value"
            :label="addr.label"
            :key="index"
          />
        </Select>
      </div>
      <div class="content-address" v-show="type === '2'">
        <Cascader :data="cityCascaderList" v-model="city" class="address-info-cascader iview-input-no-borderRs" @on-change="handleSelectCascaderCity" :clearable="false"/>
        <i>
          <span></span>
        </i>
        <Select v-model="districtIndex" class="address-info-select iview-input-no-borderLs" @on-change="handleSelectDistrict">
          <Option
            :value="-1"
            :label="$t('text.all') + $t('text.regions')"
          />
          <Option
            v-for="(item, index) in districts"
            :key="item.districtId"
            :value="index"
            :label="item.name"
          />
        </Select>
      </div>
    </section>
    <section class="store-map" v-show="type === '2'">
      <div class="store-map-select">
        <div class="map-select-list">
          <ul
            v-for="(store, index) in stores"
            :key="store.storeId"
            :class="['select-list', { 'select-list-active': selectStore && selectStore.storeId === store.storeId }]"
            @click.stop="handleSelectStore(store)">
            <li class="item-name">
              <i :class="['item-name-icon', { 'item-name-icon-active': selectStore && selectStore.storeId === store.storeId }]">
                {{ index + 1 }}
              </i>
              {{store.brandName}}（{{ store.storeName }}）
              <!-- 立即订餐 -->
              <span
                :class="{ 'item-to': !selectStore || (selectStore && selectStore.storeId !== store.storeId) }"
                @click="toStoreMenu(store, 'no')">
                {{ $t('text.address.next') }}
                <Icon type="md-arrow-dropright" />
              </span>
            </li>
            <!-- 地址 -->
            <li class="item-store-info">
              {{ $t('user.addr') }}
              &nbsp;&nbsp;:&nbsp;&nbsp;
              {{ store.storeAddress }}
            </li>
            <!-- 电话 -->
            <li class="item-store-info">
              {{ $t('user.phone.mobile') }}
              &nbsp;&nbsp;:&nbsp;&nbsp;
              {{ store.phoneNumberList[0] || $t('orders.none') }}
            </li>
          </ul>
        </div>
        <Page class="iview-page" :page-size="pageSize" :current="pageNow" size="small" :total="total" :prev-text="$t('text.previous')" :next-text="$t('text.next')" @on-change="changePage"/>
      </div>
      <div class="store-map-amap">
        <!-- <el-amap ref="map" class="amap-box" :vid="'amap-vue'"></el-amap> -->
        <el-amap ref="map" class="amap-box" vid="amap-address" :lang="$i18n.locale === 'zh' ? 'zh_cn' : 'en'" :center="center" :zoom="18" :events="events">
          <el-amap-marker
            v-for="(marker, index) in markers"
            :key="index"
            :position="marker.position"
            :events="marker.events"
            :visible="marker.visible"
            :draggable="marker.draggable"
            :vid="'amap-address-marker' + index">
            <div class="address-marker-icon">
              <i :class="['address-marker-icon', { 'address-marker-icon-active':  selectStore && selectStore.storeId === marker.storeId }]">
                {{ index + 1 }}
              </i>
            </div>
          </el-amap-marker>
          <el-amap-info-window
            :position="currentWindow.position"
            :visible="currentWindow.visible"
            :events="currentWindow.events"
            :offset="[2, -30]"
            auto-move
          >
            <div class="global-custom-modal global-booking-address-modal">
              <p class="modal-header">
                <span>{{selectStore && selectStore.brandName}}（{{ selectStore && selectStore.storeName }}）</span>
              </p>
              <div class="modal-content">
                <!-- 地址 -->
                <p>
                  {{ $t('user.addr') }}
                  &nbsp;&nbsp;:&nbsp;&nbsp;
                  {{ selectStore && selectStore.storeAddress }}
                </p>
                <!-- 电话 -->
                <p>
                  {{ $t('user.phone.mobile') }}
                  &nbsp;&nbsp;:&nbsp;&nbsp;
                  {{ (selectStore && selectStore.phoneNumberList[0]) || $t('orders.none') }}
                </p>
              </div>
            </div>
          </el-amap-info-window>
        </el-amap>
      </div>
    </section>
    <section class="address-select receiver-address" v-show="type === '1' && showReceiverAddress">
      <!-- 请选择您的就餐类型 -->
      <h3 v-if="$i18n.locale === 'zh'">{{ $t('text.please') + $t('tip.fullAddress').replace('：', '') }}</h3>
      <h3 v-if="$i18n.locale === 'en'">{{ `${$t('text.please')} ${$t('tip.addedAddress').replace(':', '')}` }}</h3>
      <Input v-model="receiverAddress" class="iview-input-no-border" :placeholder="$t('tip.such')" style="width: 376px;" />
      <Button @click.native="toStoreMenu()" class="cd-btn to-menu">
        {{ $t('text.address.next') }}
      </Button>
    </section>
  </div>
</template>

<script>
import {
  RadioGroup,
  Radio,
  Select,
  Icon,
  Cascader,
  Option,
  Page,
  Input,
} from 'iview';
import VCitySelect from '@/components/city.vue';

export default {
  name: 'booking-address',
  components: {
    RadioGroup,
    Radio,
    Select,
    VCitySelect,
    VIcon: Icon,
    Cascader,
    Option,
    Page,
    Icon,
    Input,
  },
  data() {
    return {
      showReceiverAddress: true, // 控制是否显示补全地址界面
      receiverAddress: '', // 详细地址
      type: '1', // 选择的类型
      address: '', // 输入的地址
      selectCity: {
        province: null,
        city: null,
      }, // 已选择的省市
      city: [], // 选中的城市列表
      cityList: [], // 城市列表
      cityCascaderList: [], // Cascader组件的城市列表
      searchAddressList: [], // 搜索提示字段
      isShowSearchResult: false,
      timer: null, // 防抖函数
      isLoading: false, // 控制loading
      addressList: [], // 用户地址列表
      districtIndex: -1, // 选择的区域下标
      districts: [], // 区域列表
      districtData: null, // 选择的区域数据
      total: 1, // 分页相关
      pageNow: 1,
      pageSize: 5,
      selectStore: null, // 选择的门店
      stores: [], // 门店列表
      events: {}, // 高德地图触发的事件
      center: [121.59996, 31.197646],
      markers: [
        // {
        //   position: [121.5273285, 31.21515044],
        //   events: {
        //     click: () => {
        //       alert('click marker');
        //     },
        //     dragend: (e) => {
        //       this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
        //     },
        //   },
        //   visible: true,
        //   draggable: false,
        //   template: '<span>1</span>',
        // },
      ],
      autoCompleteApi: null, // amap搜索提示
      geocoderApi: null, // amap 地址编码
      citySearch: null, // amap 城市定位
      currentWindow: { // amap显示的窗口
        position: [0, 0],
        content: '',
        events: {},
        visible: false,
      },
      userAddress: null,
    };
  },
  computed: {
    cityData() {
      // 已选择的城市，如果没选择则为省份
      if (this.selectCity.province !== null) {
        return this.cityList[this.selectCity.province].citys;
      }
      return this.cityList;
    },
  },
  created() {
    this.getCityList()
      .then(() => {
        // 获取城市列表后定位当前所在的城市
        this.positioning();
        this.getAddresses();
      });
  },
  methods: {
    // 使用用户地址订餐
    toUserAddress(address, noAdd) {
      this.userAddress = address;
      this.getAddressUserParams(address, noAdd);
    },
    getAddressUserParams(address, noAdd) {
      let params;
      try {
        params = {
          coordinate: [address.longitude, address.latitude], // 坐标数组[经度,纬度]
          searchName: address.receiverAddress + address.appendReceiverAddress, // 搜索名称，地址/门店名
          businessType: [+this.type],
        };
        if (+this.type === 1) {
          params.businessType.push(4); // 外卖预约
        }
      } catch (err) {
        return;
      }
      this.getNearStore(params, noAdd);
    },
    getAddressParams(info, noAdd) {
      let params;
      try {
        params = {
          coordinate: [info.address.location.lng, info.address.location.lat], // 坐标数组[经度,纬度]
          searchName: info.label + this.receiverAddress, // 搜索名称，地址/门店名
          businessType: [+this.type],
        };
        if (+this.type === 1) {
          params.businessType.push(4); // 外卖预约
        }
        const user = this.$service.user.getUser();
        this.userAddress = {
          receiverName: user.info.compellation || user.info.userName,
          receiverAddress: this.receiverAddress,
          appendReceiverAddress: info.label,
          longitude: info.address.location.lng,
          latitude: info.address.location.lat,
          receiverPhone: user.info.phone,
        };
      } catch (err) {
        this.userAddress = null;
        this.isLoading = false;
        return;
      }
      this.getNearStore(params, noAdd);
    },
    // 获取附近门店
    getNearStore(params, noAdd) {
      this.isLoading = true;
      this.$service.store.near({ content: params })
        .then((res) => {
          if (res.data.isServiceTime || ((params.businessType.indexOf(4) > -1) && (res.data.businessType.indexOf(4) > -1))) {
            this.toStoreMenu(res.data, noAdd);
          } else {
            throw new Error('Not ServiceTime');
          }
        })
        .catch((res) => {
          if (res.msg) {
            this.$Modal.info({ content: this.$t('tip.nearbyNoStore') });
          }
          if (res.toString() === 'Error: Not ServiceTime') {
            this.$Modal.info({ content: this.$t('store.notHours') });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 点击立即订餐事件
    toStoreMenu(store = null, noAdd) {
      // if (this.type === '1' && (typeof this.address !== 'number' || !this.searchAddressList[this.address])) {
      //   return;
      // }
      // if (!store && this.type === '2') {
      //   return;
      let select;
      if (!store && (typeof this.address === 'number' || this.searchAddressList[this.address])) {
        select = this.searchAddressList[this.address];
        select.address.coordinate = [select.address.longitude, select.address.latitude];
        select.userAddress = select.address;
      } else if (store) {
        select = {
          address: store,
          label: store.storeAddress,
        };
      } else {
        return;
      }
      if (this.userAddress) {
        select.userAddress = this.userAddress;
      }
      if (!this.receiverAddress && !store) {
        this.$Modal.info({
          content: this.$t('tip.fullAddress'),
        });
        // this.$Message.error(this.$t('tip.fullAddress'));
        return;
      }

      select.businessType = [+this.type];
      sessionStorage.setItem('booking_address_info', JSON.stringify(select));
      if (select.address.storeId) {
        if (this.type === '1') {
          let item;
          let isAdd = true;
          for (const i in this.addressList) {
            if (Object.prototype.hasOwnProperty.call(this.addressList, i)) {
              item = this.addressList[i];
              if (
                item.appendReceiverAddress === select.userAddress.receiverAddress
                && item.receiverAddress === select.userAddress.appendReceiverAddress
              ) {
                isAdd = false;
                break;
              }
            }
          }
          console.log('noAdd', noAdd);
          if (isAdd && noAdd !== 'no') {
            // 添加地址库
            const postData = {
              receiverName: select.userAddress.receiverName,
              receiverPhone: select.userAddress.receiverPhone,
              receiverAddress: select.userAddress.appendReceiverAddress,
              appendReceiverAddress: select.userAddress.receiverAddress,
              longitude: select.userAddress.longitude,
              latitude: select.userAddress.latitude,
              cityId: select.address.cityId,
              sex: 0,
            };

            this.$service.user.address.add({ content: postData })
              .then(() => {
                this.$router.push({ name: 'booking-menu', params: { storeId: select.address.storeId } });
              }).catch((err) => {
                this.$Modal.info({
                  content: err,
                });
              });
          } else {
            this.$router.push({ name: 'booking-menu', params: { storeId: select.address.storeId } });
          }
        } else {
          this.$router.push({ name: 'booking-menu', params: { storeId: select.address.storeId } });
        }
      } else {
        this.getAddressParams(select, noAdd);
      }
    },
    positioning() {
      // this.getAMap();
      if (!this.citySearch) {
        try {
          this.citySearch = new window.AMap.CitySearch();
        } catch (err) {
          if (this.cityList.length && this.cityList[0].citys.length) {
            this.selectCity.province = 0;
            [{ citys: [this.selectCity.city] }] = this.cityList;
            this.city = [this.cityList[0].citys[0].provinceId, this.cityList[0].citys[0].cityId];
            this.handleSelectCascaderCity(this.city);
          }
          return;
        }
      }
      // 查询当前所在城市
      this.citySearch.getLocalCity((status, result) => {
        const setDefaultData = () => {
          this.selectCity.province = 0;
          [{ citys: [this.selectCity.city] }] = this.cityList;
          this.city = [this.cityList[0].citys[0].provinceId, this.cityList[0].citys[0].cityId];
          this.handleSelectCascaderCity(this.city);
        };
        try {
          if (status === 'complete' && result.info === 'OK') {
            // 查询成功，result即为当前所在城市信息
            const index = this.cityList.findIndex(city => city.provinceName === result.province);
            if (index >= 0) {
              this.selectCity.province = index;
              this.selectCity.city = this.cityList[index].citys.find(city => city.cityName === result.city);
              if (this.selectCity.city) {
                // 如果地址不在列表
                this.city = [this.selectCity.city.provinceId, this.selectCity.city.cityId];
                // 手动触发区域选中事件
                this.handleSelectCascaderCity(this.city);
              } else if (this.cityList.length && this.cityList[0].citys.length) {
                setDefaultData();
              } else {
                this.selectCity.province = null;
                this.selectCity.city = null;
                // return;
              }
            }
          } else if (this.cityList.length && this.cityList[0].citys.length) {
            setDefaultData();
          }
        } catch (err) {
          if (this.cityList.length && this.cityList[0].citys.length) {
            setDefaultData();
          } else {
            this.selectCity.province = null;
            this.selectCity.city = null;
          }
        }
      });
    },
    // 处理选中门店事件
    handleSelectStore(store) {
      this.selectStore = store;
      if (!store) {
        return;
      }
      this.center = store.coordinate;
      this.currentWindow.position = store.coordinate;
      this.currentWindow.events = {};
      this.currentWindow.visible = true;
    },
    // 门店列表分页事件触发
    changePage(page) {
      this.pageNow = page;
      this.getStoreList().catch(Function.prototype);
    },
    // 区域选中事件
    handleSelectDistrict(value) {
      try {
        if (value < -1) {
          throw new Error('value < 0');
        }
        this.districtData = this.districts[value];
      } catch (err) {
        this.districtData = null;
      }
      this.isLoading = true;
      this.getStoreList()
        .then(() => {
          this.setStoreMarkers();
        })
        .catch(Function.prototype)
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 设置门店地图标记
    setStoreMarkers() {
      if (!this.stores.length) {
        return;
      }
      this.center = this.stores[0].coordinate;
      this.handleSelectStore(this.stores[0]);
      this.stores.forEach((store) => {
        this.markers.push({
          position: store.coordinate,
          visible: true,
          draggable: false,
          storeId: store.storeId,
        });
      });
    },
    // 根据城市id和区域id获取门店列表
    getStoreList() {
      let content;
      if (this.type === '1') {
        content = this.getStoreParams().in();
      } else {
        content = this.getStoreParams().out();
      }
      return this.$service.store.list.store({ content })
        .then((res) => {
          // 设置对应的数据
          this.stores = res.data.rows;
          // this.pageNow = res.data.pages;
          this.total = res.data.total;
          return res;
        });
    },
    // 获取门店列表请求参数
    getStoreParams() {
      // const content = {
      //   districtId: 0, // 行政区id 非必传
      //   cityId: 0, // 城市id
      //   searchName: '', // 搜索名称，门店 地址或者门店名称 非必传
      //   businessType: [], // 业务类型，1：外卖；2：自取；3：堂食 4外卖预约 （必传）
      //   coordinate: [], // 用户坐标（传该字段门店会按照距离由小到大排序）
      //   pageNow: 0, // 分页相关
      // };
      const base = {
        pageNow: this.pageNow, // 分页相关
        pageSize: this.pageSize,
      };
      return {
        in: () => {
          const params = {
            ...base,
            searchName: this.address,
            businessType: [1],
          };
          try {
            params.cityId = this.selectCity.city.cityId;
          } catch (err) {
            params.cityId = 0;
          }
          return params;
        },
        out: () => ({
          ...base,
          cityId: this.city[1],
          businessType: [2],
          districtId: this.districtData ? this.districtData.districtId : null,
        }),
      };
    },
    // Cascader组件选中事件
    handleSelectCascaderCity(value) {
      this.districtData = null;
      this.$service.base.district({ content: { cityId: value[1] } })
        .then((res) => {
          this.districts = res.data;
          // 触发区域选择事件
          this.handleSelectDistrict(this.districtIndex);
        })
        .catch(() => {
          this.districts = [];
        });
    },
    // 选中城市
    // item 选中对象的值
    // index 选中对象的数组下标
    handleSelectCity({ item, index }) {
      this.address = '';
      this.longitude = 0;
      this.latitude = 0;
      this.searchAddressList = [];
      if (item.citys) {
        this.selectCity.province = index;
        return;
      }
      this.selectCity.city = item;
      this.$refs.city.close();
      this.getAMap();
      console.log(this.selectCity.city && this.selectCity.city.cityName);
      this.autoCompleteApi.setCity((this.selectCity.city && this.selectCity.city.cityName) || '全国');
    },
    getAMap() {
      if (!window.AMap) {
        return;
      }
      if (!this.autoCompleteApi) {
        // 高德地图api 初始化搜索提示插件
        // 实例化Autocomplete
        const autoOptions = {
          city: (this.selectCity.city && this.selectCity.city.cityName) || '全国',
          citylimit: true,
        };
        this.autoCompleteApi = new window.AMap.Autocomplete(autoOptions);
      }
      if (!this.geocoderApi) {
        // 高德地图api 初始化搜索提示插件
        const autoOptions = {
          city: (this.selectCity.city && this.selectCity.city.cityName) || '全国',
        };
        this.geocoderApi = new window.AMap.Geocoder(autoOptions);
      }
    },
    autoComplete(query) {
      // 如果搜索插件为空
      if (this.address && this.searchAddressList[this.address] && this.searchAddressList[this.address].label === query) {
        return;
      }
      this.getAMap();
      if (this.timer) clearTimeout(this.timer);
      this.isShowSearchResult = true;
      this.timer = setTimeout(() => {
        this.longitude = 0;
        this.latitude = 0;
        if (query === '') {
          this.isShowSearchResult = false;
          this.searchAddressList.splice(0);
          return;
        }
        Promise.all([this.storeWhiteList(query), this.amapSearch(query)])
          .then(([white, amap]) => {
            this.searchAddressList = [].concat(amap, white);
          })
          .catch(Function.prototype);
        // 调用高德地图联想地址
        // this.autoCompleteApi.search(query, (status, result) => {
        //   if (status === 'no_data') {
        //     // 没有数据的处理
        //     this.searchAddressList = [];
        //     this.isShowSearchResult = false;
        //     return;
        //   }
        //   if (status === 'error') {
        //     // 出现错误的处理
        //     this.searchAddressList = [];
        //     this.isShowSearchResult = false;
        //     return;
        //   }
        //   const { tips = [] } = result;
        //   this.isShowSearchResult = false;
        //   this.searchAddressList = tips
        //     .filter(obj => (typeof obj.address === 'string' && obj.address) || (Array.isArray(obj.address) && obj.address.length > 0))
        //     .map(val => ({ value: val.address, label: val.address, address: val }));
        // });
      }, 200);
    },
    storeWhiteList(query) {
      // 搜索门店地址白名单
      return this.$service.store.list.white({ content: { address: query } })
        .then(res => res.data.map((address, index) => ({
          value: index,
          label: address.address,
          address,
        })))
        .catch(Function.prototype);
    },
    amapSearch(query) {
      // 高德地图地址联想
      return new Promise((resolve, reject) => {
        this.autoCompleteApi.search(query, (status, result) => {
          if (status === 'no_data') {
            // 没有数据的处理
            this.isShowSearchResult = false;
            resolve([]);
          }
          if (status === 'error') {
            // 出现错误的处理
            this.isShowSearchResult = false;
            reject(new Error('amap search error'));
          }
          const { tips = [] } = result;
          this.isShowSearchResult = false;
          resolve(tips
            .filter(obj => !/\u516C\u4EA4|\u5730\u94C1/.test(obj.name) && obj.location !== undefined)
            .map((val, index) => ({ value: index, label: val.address + val.name, address: val })));
          // .filter(obj => (typeof obj.address === 'string' && obj.address) && !/\u516C\u4EA4|\u5730\u94C1/.test(obj.name))
          // .map((val, index) => ({ value: index, label: val.address, address: val })));
        });
      });
    },
    checkItem(address) {
      const item = this.searchAddressList.filter(val => val.value === address);
      if (!item.length) {
        return;
      }
      const addr = item[0].address;
      this.longitude = addr.location.lng;
      this.latitude = addr.location.lat;
      // this.$refs.amap.$$getInstance().setCenter([this.longitude, this.latitude]);
      this.isShowSearchResult = false;
      // this.searchAddressList.splice(0);
    },
    // 获取城市列表
    getCityList() {
      return this.$service.project.cityList({})
        .then((data) => {
          const city = {};
          const cityCascader = {};
          data.data.forEach((item) => {
            if (!city[item.provinceId]) {
              city[item.provinceId] = {
                provinceName: item.provinceName,
                provinceId: item.provinceId,
                citys: [],
              };
              cityCascader[item.provinceId] = {
                label: item.provinceName,
                value: item.provinceId,
                children: [],
              };
            }
            city[item.provinceId].citys.push(item);
            cityCascader[item.provinceId].children.push({
              label: item.cityName,
              value: item.cityId,
            });
          });
          this.cityList = Object.values(city);
          this.cityCascaderList = Object.values(cityCascader);
          return data;
        })
        .catch((err) => {
          this.cityList = [];
          this.$Message.error(err);
          // this.$Message.error(' 获取城市列表失败');
        });
    },
    // 获取用户地址
    getAddresses() {
      // this.isLoading = true;
      this.addressList.splice(0);
      return this.$service.user.address.getter({})
        .then((result) => {
          if (result.data === undefined) {
            return;
          }
          this.addressList = result.data;
        })
        .catch(() => {
          this.addressList = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};

</script>

<style lang="sass" scoped>
@mixin common-hader
  font-size: 22px
  color: #0f9675
  margin-bottom: 16px
@mixin common-marker-icon
  width: 17px
  height: 23px
  color: #fff
  line-height: 19px
  text-align: center
  font-style: normal
  display: inline-block
  font-size: 12px
  background: url('../../assets/image/icon/icon-mapMarker-green.png') no-repeat
  &-active
    background: url('../../assets/image/icon/icon-mapMarker-red.png') no-repeat
.address
  min-height: 623px
  overflow: hidden
  background-color: #f5f5f5
  padding: 33px 0 20px 33px
  margin-bottom: 14px
  .address-list
    width: 362px
    float: right
    margin-right: 25px
    min-height: 380px
    h3
      @include common-hader
    .address-list-item
      overflow-y: auto
      max-height: 360px
      ul
        width: 342px
        color: #7a7a7a
        cursor: pointer
        padding: 12px 16px
        margin-bottom: 16px
        background-color: #fff
        border: 1px solid #e0e0e0
        max-height: 360px
        &:hover
          border-color: #0f9675
        li
          line-height: 26px
  .business-type
    &.business-type-block
      display: block
    height: 120px
    width: 400px
    display: inline-block
    h3
      @include common-hader
    .business-type-radio
      margin: 0 60px 0 4px
  .store-map
    margin-top: 23px
    border: 1px solid #e0e0e0
    width: 880px
    display: flex
    .store-map-select
      width: 300px
      background-color: #fff
      .map-select-list
        height: 370px
        overflow-y: auto
        .select-list
          cursor: pointer
          padding: 10px
          border-bottom: 1px solid #e0e0e0
          &.select-list-active
            background-color: #f2f5f7
          &:hover
            li
              .item-to
                display: initial
          li
            &.item-name
              color: #0f9675
              font-size: 14px
              line-height: 32px
              .item-name-icon
                @include common-marker-icon
              span
                font-size: 12px
                float: right
            &.item-store-info
              padding-left: 24px
            color: #aaa
            line-height: 18px
            .item-to
              display: none
      .iview-page
        padding-left: 15px
        border-top: 1px solid #e0e0e0
    .store-map-amap
      height: 398px
      width: 580px
      .address-marker-icon
        @include common-marker-icon
      .global-booking-address-modal
            min-width: 243px
            max-width: 243px
            .modal-header
              padding-bottom: 0
              line-height: 31px
              font-size: 14px
              padding: 0 10px
              background: none repeat scroll 0 0 #f9f9f9
            .modal-content
              color: #aaa
              padding: 6px
              padding-left: 13px
              text-align: left
              background-color: white
  .address-select
    width: 400px
    display: inline-block
    h3
      @include common-hader
    &.receiver-address
      margin-top: 16px
    .to-menu
      padding: 8px 30px
      margin: 50px 0 0 126px
    .content-address
      display: flex
      height: 32px
      >i
        width: 5px
        background-color: #fff
        border-top: 1px solid #e0e0e0
        border-bottom: 1px solid #e0e0e0
        padding: 5px 1px
        span
          display: inline-block
          border-right: 1px solid #e0e0e0
          width: 1px
          height: 100%
      .content-address-select
        border-right-width: 0
      .iview-input
        width: 290px
      .global-city-select-tips
        .ivu-icon
          vertical-align: text-bottom
        font-size: 12px
        line-height: 32px
      .address-info-cascader, .address-info-select
        width: 117px
</style>
